import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { css } from 'styled-components';
import darken from 'polished/lib/color/darken';
import 'react';
import { visuallyHiddenStyles } from '../../utils/styleHelpers.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
const baseInputStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  padding: ", ";\n  border: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  [dir='rtl'] & {\n    font-family: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[disabled] {\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    box-shadow: ", ";\n  }\n"])), _ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return "".concat(spacing.halfSpacing, " ").concat(spacing.baseSpacing);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return "1px solid ".concat(theme.colors.accents.dark);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.radii.default;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.boxShadows.subtle;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.surface;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.fonts.body;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.fontSizes.standard;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.lineHeights.body;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.text;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.rtlFonts.body;
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.textMuted;
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.colors.accents.muted;
}, _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.boxShadows.focus;
});
const errorInputStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-color: #d32f2f;\n  &:focus-visible {\n    box-shadow: 0 0 0 2px #d32f2f;\n  }\n"])));
const Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "formstyles__Label",
  componentId: "sc-3dq2r2-0"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  ", "\n\n  ", "\n"])), _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.fontSizes.standard;
}, _ref15 => {
  let {
    visuallyHide
  } = _ref15;
  return visuallyHide && visuallyHiddenStyles;
}, _ref16 => {
  let {
    disabled
  } = _ref16;
  return disabled && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      opacity: ", ";\n      cursor: not-allowed;\n    "])), _ref17 => {
    let {
      theme
    } = _ref17;
    return theme.opacities.disabled;
  });
});
const Input = /*#__PURE__*/styled.input.withConfig({
  displayName: "formstyles__Input",
  componentId: "sc-3dq2r2-1"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  ", ";\n"])), baseInputStyles, _ref18 => {
  let {
    hasError
  } = _ref18;
  return hasError && errorInputStyles;
});

/** @todo the select bg img needs to change color per theme */
const Select = /*#__PURE__*/styled.select.withConfig({
  displayName: "formstyles__Select",
  componentId: "sc-3dq2r2-2"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  -webkit-appearance: none;\n  appearance: none;\n  background: ", ";\n  [dir='rtl'] & {\n    background-position-x: ", ";\n  }\n  ", ";\n"])), baseInputStyles, _ref19 => {
  let {
    theme
  } = _ref19;
  return "".concat(theme.colors.surface, " url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAlUlEQVQYla3QIQoCURSF4U8HDC7CnVgEbe5AQZ0wyT24AIsGYZAJdjFYJjjZDbgDixgttgeWp2hT8C8XzvnhXi7/ppbkxQUVRiFLw3uZ5EUNG/TqOGCAdSzeWWCIqo4xdnGunnKSFzNMUWLyDBvYoo85zljiiG7I0vtrVZRLdGJ0Qjtk6Q0+bkryook9WlG6/v6fb3kAK30mP5R5W1AAAAAASUVORK5CYII=)\n    right ").concat(theme.spacing.baseSpacing, " top 50% no-repeat");
}, _ref20 => {
  let {
    theme
  } = _ref20;
  return theme.spacing.baseSpacing;
}, _ref21 => {
  let {
    hasError
  } = _ref21;
  return hasError && errorInputStyles;
});

/** Shared styling for radio + checkboxes */
const optionStyles = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: inline-block;\n  border-color: ", ";\n  cursor: pointer;\n\n  ", "\n"])), _ref22 => {
  let {
    theme
  } = _ref22;
  return theme.colors.text;
}, _ref23 => {
  let {
    visuallyHide
  } = _ref23;
  return visuallyHide && visuallyHiddenStyles;
});
const OptionInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "formstyles__OptionInput",
  componentId: "sc-3dq2r2-3"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), optionStyles);

/**
 * @deprecated Please use `OptionInput`, {Checkbox} will be removed on the 08/11/21.
 */
const Checkbox = /*#__PURE__*/styled.input.withConfig({
  displayName: "formstyles__Checkbox",
  componentId: "sc-3dq2r2-4"
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n"])), optionStyles);

/**
 * @deprecated Please use `OptionInput`, {InputRadio} will be removed on the 08/11/21.
 */
const InputRadio = /*#__PURE__*/styled.input.withConfig({
  displayName: "formstyles__InputRadio",
  componentId: "sc-3dq2r2-5"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", "\n"])), optionStyles);
const requiredStyles = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  &::after {\n    content: '*';\n    margin-inline-start: ", ";\n    color: ", ";\n  }\n"])), _ref24 => {
  let {
    theme
  } = _ref24;
  return theme.spacing.quarterSpacing;
}, _ref25 => {
  let {
    theme
  } = _ref25;
  return darken(0.4, theme.colors.alerts.error);
});
const Required = /*#__PURE__*/styled.span.withConfig({
  displayName: "formstyles__Required",
  componentId: "sc-3dq2r2-6"
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", "\n"])), _ref26 => {
  let {
    required,
    hideRequired
  } = _ref26;
  return required && !hideRequired && requiredStyles;
});

export { Checkbox, Input, InputRadio, Label, OptionInput, Required, Select, baseInputStyles, errorInputStyles, requiredStyles };
